import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const TextIndentIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M15.6666 1.33337H0.999959C0.815864 1.33337 0.666626 1.48261 0.666626 1.66671V2.33337C0.666626 2.51747 0.815864 2.66671 0.999959 2.66671H15.6666C15.8507 2.66671 16 2.51747 16 2.33337V1.66671C16 1.48261 15.8507 1.33337 15.6666 1.33337Z"
        fill={color}
      />
      <path
        d="M15.6666 13.3334H0.999959C0.815864 13.3334 0.666626 13.4826 0.666626 13.6667V14.3334C0.666626 14.5175 0.815864 14.6667 0.999959 14.6667H15.6666C15.8507 14.6667 16 14.5175 16 14.3334V13.6667C16 13.4826 15.8507 13.3334 15.6666 13.3334Z"
        fill={color}
      />
      <path
        d="M15.6667 5.33337H8.33333C8.14924 5.33337 8 5.48261 8 5.66671V6.33337C8 6.51747 8.14924 6.66671 8.33333 6.66671H15.6667C15.8508 6.66671 16 6.51747 16 6.33337V5.66671C16 5.48261 15.8508 5.33337 15.6667 5.33337Z"
        fill={color}
      />
      <path
        d="M15.6667 9.33337H8.33333C8.14924 9.33337 8 9.48261 8 9.66671V10.3334C8 10.5175 8.14924 10.6667 8.33333 10.6667H15.6667C15.8508 10.6667 16 10.5175 16 10.3334V9.66671C16 9.48261 15.8508 9.33337 15.6667 9.33337Z"
        fill={color}
      />
      <path
        d="M3.22 8.66666V10.04C3.22 10.3 3.53333 10.4267 3.71333 10.2467L5.62 8.34C5.80667 8.15333 5.80667 7.84666 5.62 7.65333L3.71333 5.74666C3.52667 5.56 3.22 5.69333 3.22 5.95333V7.32666H0.666667C0.3 7.32666 0 7.62666 0 7.99333C0 8.36 0.3 8.66 0.666667 8.66H3.22V8.66666Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TextIndentIcon.displayName = 'TextIndentIcon';
